const price = {
  placeholder: 'Hinweise / Sonderwünsche',
  salesTaxBefore: 'inkl.',
  salesTaxAfter: 'MwSt. zzgl.',
  shipping: 'Versandkosten',
  deliveryTime: 'Lieferzeit',
  addButton: 'In den Warenkorb',
  missingInput: {
    title: 'Unvollständige Angaben',
    content: '<p>Bestellung aufgrund <strong>fehlender Eingaben</strong> leider nicht realisierbar!</p><p>Bitte vervollständigen und bestätigen Sie folgende Angaben:</p>',
    form: 'Form und Maße',
    material: 'Material und Farbe',
    rand: 'Randgestaltung'
  }
}

export default {
  price
}
